"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  @media print, screen and (min-width: ", "px) {\n    max-width: 640px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  overflow: hidden;\n  text-align: center;\n  margin-bottom: 30px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Container = _styledComponents.default.div(_templateObject(), _Constant.Color.WHITE);

var Screenshot = _styledComponents.default.div(_templateObject2());

var ScreenshotImage = _styledComponents.default.img(_templateObject3(), _Constant.Width.MD);

var WebcamImage = function WebcamImage(_ref) {
  var image = _ref.image,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(Container, null, image && /*#__PURE__*/_react.default.createElement(Screenshot, null, /*#__PURE__*/_react.default.createElement(ScreenshotImage, {
    src: image,
    alt: "Webcam screenshot",
    className: "fs-exclude"
  })), children);
};

WebcamImage.propTypes = {
  image: _propTypes.default.node.isRequired,
  children: _propTypes.default.node
};
WebcamImage.defaultProps = {
  children: null
};
var _default = WebcamImage;
exports.default = _default;